import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Price.module.scss";
import Link from "next/link";
import { useSubscriptionStatusQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormatWatchPrice(_ref) {
  var _data$subscriptionSta;
  let {
    price,
    type,
    ext,
    isLoggedIn,
    // discountPrice,
    discountFlag,
    course
  } = _ref;
  const {
    data,
    loading: loadingSubscriptionStatus
  } = useSubscriptionStatusQuery({
    variables: {
      courseId: Number(course === null || course === void 0 ? void 0 : course.id)
    }
  });
  if (isLoggedIn && loadingSubscriptionStatus) {
    return null;
  }
  const isTrialEnabled = isLoggedIn ? data === null || data === void 0 || (_data$subscriptionSta = data.subscriptionStatus) === null || _data$subscriptionSta === void 0 ? void 0 : _data$subscriptionSta.is_trial_enabled : true;
  const showDiscount = isLoggedIn && discountFlag;
  const showTrial = isTrialEnabled && (course === null || course === void 0 ? void 0 : course.trial_flag);
  if (type === "svod" && !showTrial /* && !showDiscount */) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.watchPrice,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u6708\u984D"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
        })]
      })
    });
  }
  // else if (type === "svod" && !showTrial && showDiscount) {
  //   return (
  //     <div className={styles.watchPrice}>
  //       <div className={styles.watchPrices}>
  //         <div className={styles.priceLeft}>月額</div>
  //         <div className={styles.priceRight}>
  //           <span className={styles.priceAmount}>{formatPrice(price)}円</span>
  //           （税込）
  //         </div>
  //       </div>
  //       <div className={styles.discountLink}>
  //         <p>
  //           ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //           <Link
  //             href={routes.campaignWithBroadcast}
  //             target="_blank"
  //             rel="noopener noreferrer">

  //               こちら

  //           </Link>
  //           をご確認ください
  //           <br />
  //           ※対象の放送商品をご購入中の方は月額
  //           {formatPrice(discountPrice)}円(税込){ext}{" "}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }
  else if (type === "svod" && showTrial /* && !showDiscount */) {
    return /*#__PURE__*/_jsx("div", {
      className: `${styles.watchPrice} ${styles.trialFlag}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.trialDurationArea,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.slate,
          children: /*#__PURE__*/_jsxs("span", {
            className: styles.bold,
            children: ["\u3010\u521D\u56DE\u8CFC\u5165\u9650\u5B9A\u3011", course.trialTermText]
          })
        }), /*#__PURE__*/_jsx("br", {}), course.trialText, "\u671F\u9593\u5F8C\u306F\u6708\u984D", /*#__PURE__*/_jsx("span", {
          className: styles.bold,
          children: formatPrice(price)
        }), "\u5186\uFF08\u7A0E\u8FBC\uFF09", ext, course.valuePlan && /*#__PURE__*/_jsxs("div", {
          children: [course.trialTermText, "\u306B\u3064\u3044\u3066\u306E\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
            href: routes.valuePlanCampaignDetail,
            target: "_blank",
            rel: "noopener noreferrer",
            children: "\u3053\u3061\u3089"
          }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
        })]
      })
    });
  }
  // else if (type === "svod" && showTrial && showDiscount) {
  //   return (
  //     <div className={`${styles.watchPrice} ${styles.trialFlag}`}>
  //       <div className={styles.trialDurationArea}>
  //         <span className={styles.slate}>
  //           <span className={styles.bold}>
  //             【初回購入限定】{course.trialTermText}
  //           </span>
  //         </span>
  //         <br />
  //         {course.trialText}期間後は月額
  //         <span className={styles.bold}>{formatPrice(price)}</span>
  //         円（税込）{ext}
  //         {course.valuePlan && (
  //           <div>
  //             {course.trialTermText}についての詳細は
  //             <Link
  //               href={routes.valuePlanCampaignDetail}
  //               target="_blank"
  //               rel="noopener noreferrer">

  //                 こちら

  //             </Link>
  //             からご確認ください。
  //           </div>
  //         )}
  //       </div>
  //       <div className={styles.discountLink}>
  //         <p>
  //           ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //           <Link
  //             href={routes.campaignWithBroadcast}
  //             target="_blank"
  //             rel="noopener noreferrer">

  //               こちら

  //           </Link>
  //           をご確認ください。
  //           <br />
  //           ※対象の放送商品をご購入中の方は月額
  //           {formatPrice(discountPrice)}円(税込){ext}{" "}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }
  else if (type === "tvod" /* && !showDiscount */) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.watchPrice,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u91D1\u984D"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
        })]
      })
    });
  }
  // else if (type === "tvod" && showDiscount) {
  //   return (
  //     <div className={styles.watchPrice}>
  //       <div className={styles.watchPrices}>
  //         <div className={styles.priceLeft}>金額</div>
  //         <div className={styles.priceRight}>
  //           <span className={styles.priceAmount}>{formatPrice(price)}円</span>
  //           （税込）
  //           <span className={styles.discountLink}>
  //             ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //             <Link
  //               href={routes.campaignWithBroadcast}
  //               target="_blank"
  //               rel="noopener noreferrer">

  //                 こちら

  //             </Link>
  //             をご確認ください
  //             <br />
  //             ※対象の放送商品をご購入中の方は{formatPrice(discountPrice)}
  //             円(税込){ext}
  //           </span>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
}